<template>
  <div>
    <h5 class="mb-3 font-weight-bold">Export Splits</h5>

    <GroupedOptions
      v-model="innerValue"
      :options="options"
      button-classes="badge badge-pill mr-2 mb-2 text-capitalize"
      name="export_by"
    />

    <p class="small">
      Market Export splits the BDX in an approved format for submission.
      To split in any other way, select Custom Split.<br />Email
      <a href="mailto:support@limeiq.com" class="text-primary font-weight-bold"
      >support@limeiq.com</a
      >
      with any inquiries regarding exports.
    </p>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'

import GroupedOptions from '@components/GroupedOptions'

export default defineComponent({
  name: 'SaveReportWizardMarketExport',
  components: {
    GroupedOptions
  },
  emits: ['input'],
  props: {
    value: String,
    label: String
  },
  setup(props, { emit }) {
    const options = [
      {
        value: 'market_export',
        label: 'Market Split',
      },
      {
        value: 'custom_export',
        label: 'Custom Split',
      }
    ]

    const innerValue = computed({
      get() {
        return props.value
      },
      set(newValue) {
        emit('input', newValue)
      }
    })

    return {
      options,
      innerValue
    }
  }
})
</script>
